import styled from 'styled-components';
import {Link} from 'react-router-dom';

interface OptionProps {
  active?: number;
}

export const Container = styled.div`
  .collapse-css-transition {
    transition: height 280ms cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export const Button = styled.div<ButtonProps>`
  display: flex;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
`;

export const LinkButton = styled(Link)<ButtonProps>`
  display: flex;
  align-items: center;
  padding: 15px 30px;
  transition: all 0.1s ease-in-out;
  cursor: pointer;

  > svg {
    transition: all 280ms ease-in-out;
    transform: ${(props) => props.opened && 'rotate(-180deg)'};
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.primary};
  }
`;

export const Label = styled.div<OptionProps>`
  border-radius: 5px;
  display: flex;
  flex: 1;
  gap: 10px;
  align-items: center;
  color: ${(props) => props.theme.colors.text};
  font-weight: 600;
  font-size: 12px;

  background-color: ${(props) =>
    props.active ? props.theme.colors.primaryLight : 'white'};
`;

export const Row = styled.div<OptionProps>`
  gap: 10px;
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 8px;
  cursor: pointer;
`;

export const Option = styled.span<OptionProps>`
  display: block;
  color: ${(props) => props.theme.colors.text};
  font-size: 16px;
  cursor: pointer;
  font-weight: 400;
  line-height: 20px;

  ${(props) =>
    props.active &&
    `
      color: ${props.theme.colors.invertedText};
    `}
`;

interface RouteNameProps {
  active: boolean;
}

export const RouteName = styled.p<RouteNameProps>`
  font-weight: 400;
`;

interface ButtonProps {
  opened?: boolean;
}

export const MainButton = styled.div<ButtonProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  background-color: ${(props) =>
    props.opened ? props.theme.colors.primaryLight : props.theme.colors.card};

  h3,
  svg {
    color: ${(props) =>
      props.opened ? props.theme.colors.primary : props.theme.colors.text};
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryLight};
    h3,
    svg {
      color: ${(props) => props.theme.colors.primary};
    }
  }
`;

export const MainTitle = styled.h3<OptionProps>`
  border-radius: 5px;
  display: flex;
  flex: 1;
  gap: 10px;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
`;
